import { render, staticRenderFns } from "./NewLoginPassword.vue?vue&type=template&id=5529e546"
import script from "./NewLoginPassword.vue?vue&type=script&lang=js"
export * from "./NewLoginPassword.vue?vue&type=script&lang=js"
import style0 from "./NewLoginPassword.vue?vue&type=style&index=0&id=5529e546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports